import React from "react";

import pdf from "@react-pdf/renderer";

import { colors } from "@/theme/overrides/colors";
import Bread from "@assets/icons/breads-1.png";
import Egg from "@assets/icons/egg-1.png";
import Fish from "@assets/icons/fish-1.png";
import Fruit from "@assets/icons/fruits-1.png";
import Meat from "@assets/icons/meat-1.png";
import Milk from "@assets/icons/milk-1.png";
import Sugar from "@assets/icons/sugar-1.png";
import Fat from "@assets/icons/trans-fat-1.png";
import Vegetable from "@assets/icons/vegetable-1.png";

import Flex from "./components/layout/Flex";
import Subheader from "./components/Subheader";
import {
  mulish,
  mulishBold,
  mulishExtraBold,
  mulishExtraLight,
  mulishLight,
  mulishMedium,
  mulishSemiBold,
} from "./fonts";

const { Page, StyleSheet, Font, View, Text, Image } = pdf;

Font.register({
  family: "Mulish",
  fonts: [
    {
      src: mulish,
      fontWeight: "normal",
    },
    {
      src: mulishBold,
      fontWeight: "bold",
    },
    {
      src: mulishExtraBold,
      fontWeight: "ultrabold",
    },
    {
      src: mulishExtraLight,
      fontWeight: "ultralight",
    },
    {
      src: mulishLight,
      fontWeight: "light",
    },
    {
      src: mulishMedium,
      fontWeight: "medium",
    },
    {
      src: mulishSemiBold,
      fontWeight: "semibold",
    },
  ],
});

// Create styles
const styles = StyleSheet.create({
  foodExchangeItemTitle: {
    fontWeight: 700,
    fontSize: 14,
    color: "#595F68",
  },
  foodExchangeSubItemItemTitle: {
    fontWeight: 700,
    fontSize: 9,
    alignSelf: "center",
  },
  foodExchangeSubItemTitle: {
    fontWeight: 700,
    fontSize: 14,
    color: colors.gray,
  },
  calculationTableContainer: {
    backgroundColor: colors.dark,
    color: "white",
    width: "100%",
    marginTop: 24,
  },
  calculationTableHeaderContainer: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    padding: 8,
  },
  calculationTableHeader: {
    fontWeight: 600,
    fontSize: 12,
    flex: 1,
  },
  calculationTableRowContainer: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    backgroundColor: colors.light,
    padding: 8,
  },
  calculationTableRow: {
    color: "#0B1B26",
    fontWeight: 700,
    fontSize: 12,
    flex: 1,
  },
  calculationTableRowCaption: {
    color: colors.gray,
  },

  mainContainer: {
    display: "flex",
  },
  page: {
    padding: "0px",
    fontFamily: "Mulish",
    color: colors.dark,
    fontSize: "16px",
  },
  content: {
    padding: "12px 24px 0px 24px",
    height: "auto",
  },
  foodExchangeContainer: {
    flex: 1,
    padding: 5,
    position: "relative",
  },
  foodExchangeContainer2: {
    flex: 1,
    padding: 3,
    position: "relative",
  },
  foodExchangeItemContainer: {
    width: "100%",
    height: "auto",
    padding: 10,
    border: "2.4px dotted #EDF0F5",
    borderRadius: 10,
  },
  foodExchangeItemContainer2: {
    width: "100%",
    height: "auto",
    padding: 5,
  },
  card: {
    border: "2.4px dotted #EDF0F5",
    borderRadius: 10,
  },
  foodItemIcon: {
    width: "61px",
    height: "62px",
    alignSelf: "center",
    marginTop: "15px",
    marginBottom: "15px",
  },
  foodItemIcon2: {
    width: "40px",
    height: "40px",
    alignSelf: "center",
    marginTop: "5px",
    marginBottom: "5px",
  },
  rowItem: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "space-between",
    fontSize: "10px",
    padding: "5px 3px",
  },
  rowItem2: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "space-between",
    fontSize: "10px",
    padding: "3px 2px",
  },
  rowHeader: {
    backgroundColor: "#112340",
    fontWeight: 700,
    fontSize: "12px",
    color: "#FFFFFF",
    borderRightWidth: 0,
    borderBottomWidth: 0,
    borderTopLeftRadius: 5,
    borderTopRightRadius: 5,
  },
  centerText: {
    textAlign: "center",
  },
  rowBody: {
    fontSize: "9px",
    fontWeight: 600,
    color: "#112340",
  },
});

type FELTableBodyProps = {
  foodOption: string;
  servingSize: string;
  background: string;
};
const FELTableBody: React.FC<FELTableBodyProps> = ({
  foodOption,
  servingSize,
  background,
}) => {
  return (
    <View
      style={[styles.rowItem, styles.rowBody, { backgroundColor: background }]}
    >
      <View style={{ width: "100%" }}>
        <Flex justifyContent="spaceBetween" flexDirection="row">
          <Text style={{ width: "50%" }}>{foodOption}</Text>
          <Text style={{ width: "50%" }}>{servingSize}</Text>
        </Flex>
      </View>
    </View>
  );
};
const FELTableBody2: React.FC<FELTableBodyProps> = ({
  foodOption,
  servingSize,
  background,
}) => {
  return (
    <View
      style={[styles.rowItem2, styles.rowBody, { backgroundColor: background }]}
    >
      <View style={{ width: "100%" }}>
        <Flex justifyContent="spaceBetween" flexDirection="row">
          <Text style={{ width: "50%" }}>{foodOption}</Text>
          <Text style={{ width: "50%" }}>{servingSize}</Text>
        </Flex>
      </View>
    </View>
  );
};

const Footer: React.FC = () => {
  return (
    <View style={{ width: "100%", marginTop: "40px" }}>
      <Text
        style={{ fontWeight: "semibold", fontSize: "8px", color: "#363E45" }}
      >
        Powered by Nutricoach. Copyright © {new Date().getFullYear()}. All
        Rights Reserved
      </Text>
      <Text
        style={{ fontWeight: "semibold", fontSize: "7px", color: "#7D8797" }}
      >
        NutriCoach does not own any contents of this program. The program and
        its contents are created and owned by the clients personal nutrition
        professional. The program has been created specifically for the intended
        client of the personal nutrition professional. Nutricoach, Inc. will not
        be liable for consequences of any kind as a result of using the
        recommendations in this program.
      </Text>
    </View>
  );
};

const FELTableHeader: React.FC = () => {
  return (
    <View style={[styles.rowItem, styles.rowHeader]}>
      <View style={{ width: "100%" }}>
        <Flex justifyContent="spaceBetween" flexDirection="row">
          <Text style={[styles.centerText, { width: "50%" }]}>Food Option</Text>
          <Text style={[styles.centerText, { width: "50%" }]}>
            Serving Size
          </Text>
        </Flex>
      </View>
    </View>
  );
};

const PDFFelTemplate: React.FC = () => {
  return (
    <Page size="A4" style={styles.page}>
      <Subheader title="Common Food Exchange List" />
      <View style={styles.content}>
        <View style={styles.mainContainer}>
          <Flex>
            <View style={[styles.foodExchangeContainer, { padding: 0 }]}>
              <View style={{ width: "100%" }}>
                <Flex>
                  <View style={styles.foodExchangeItemContainer}>
                    <View style={{ width: "100%" }}>
                      <Flex flexDirection="column">
                        <Text style={styles.foodExchangeItemTitle}>
                          Vegetable (16 Calories)
                        </Text>
                        <Image src={Vegetable} style={styles.foodItemIcon} />
                        <FELTableHeader />
                        <FELTableBody
                          foodOption="Leafy Vegetables"
                          servingSize="1/2 Cup Cooked or 1 Cup Raw"
                          background="#FFFFFF"
                        ></FELTableBody>
                        <FELTableBody
                          foodOption="Whole Vegetables"
                          servingSize="1/2 Cup Cooked or 1 Cup Raw"
                          background="#F5F7FA"
                        ></FELTableBody>
                      </Flex>
                    </View>
                  </View>
                </Flex>
              </View>
            </View>
            <View style={styles.foodExchangeContainer}>
              <View style={{ width: "100%" }}>
                <Flex>
                  <View style={styles.foodExchangeItemContainer}>
                    <View style={{ width: "100%" }}>
                      <Flex flexDirection="column">
                        <Text style={styles.foodExchangeItemTitle}>Milk</Text>
                        <Image src={Milk} style={styles.foodItemIcon} />
                        <FELTableHeader />
                        <FELTableBody
                          foodOption="Whole milk (150 Calories)"
                          servingSize="1/2 Cup evap or 4 tbs powdered milk"
                          background="#FFFFFF"
                        ></FELTableBody>
                        <FELTableBody
                          foodOption="Low fat milk (100 Calories)"
                          servingSize="4 tbs powdered milk or 1 tetra brick"
                          background="#F5F7FA"
                        ></FELTableBody>
                        <FELTableBody
                          foodOption="Non-Fat / Skimmed Milk (100 Calories)"
                          servingSize="4 tbs powdered milk or 1 tetra brick"
                          background="#FFFFFF"
                        ></FELTableBody>
                      </Flex>
                    </View>
                  </View>
                </Flex>
              </View>
            </View>
          </Flex>
          <Flex>
            <View style={styles.foodExchangeContainer}>
              <View style={{ width: "100%" }}>
                <Flex>
                  <View style={styles.foodExchangeItemContainer}>
                    <View style={{ width: "100%" }}>
                      <Flex flexDirection="column">
                        <Text style={styles.foodExchangeItemTitle}>
                          Rice / Breads / Substitutes (100 Calories)
                        </Text>
                        <Image src={Bread} style={styles.foodItemIcon} />
                        <FELTableHeader />
                        <FELTableBody
                          foodOption="Rice"
                          servingSize="1/2 Cup Cooked"
                          background="#FFFFFF"
                        ></FELTableBody>
                        <FELTableBody
                          foodOption="Congee"
                          servingSize="1 1/2 Cup thick consistency"
                          background="#F5F7FA"
                        ></FELTableBody>
                        <FELTableBody
                          foodOption="Pandesal"
                          servingSize="3 pcs. Medium sized"
                          background="#FFFFFF"
                        ></FELTableBody>
                        <FELTableBody
                          foodOption="Hotdog Roll"
                          servingSize="1 pc."
                          background="#F5F7FA"
                        ></FELTableBody>
                        <FELTableBody
                          foodOption="Hamburger Bun"
                          servingSize="1 pc."
                          background="#FFFFFF"
                        ></FELTableBody>
                        <FELTableBody
                          foodOption="Sponge Cake"
                          servingSize="1 Slice 5x5 cm"
                          background="#F5F7FA"
                        ></FELTableBody>
                        <FELTableBody
                          foodOption="Whole wheat bread"
                          servingSize="2 Slices"
                          background="#FFFFFF"
                        ></FELTableBody>
                        <FELTableBody
                          foodOption="Corn flakes"
                          servingSize="1 Cup"
                          background="#F5F7FA"
                        ></FELTableBody>
                        <FELTableBody
                          foodOption="Corn kernel boiled"
                          servingSize="1 Cup"
                          background="#FFFFFF"
                        ></FELTableBody>
                        <FELTableBody
                          foodOption="Noodles / Oatmeal"
                          servingSize="1 Cup"
                          background="#F5F7FA"
                        ></FELTableBody>
                        <FELTableBody
                          foodOption="Mashed Potato"
                          servingSize="1 1/3 Cup"
                          background="#FFFFFF"
                        ></FELTableBody>
                        <FELTableBody
                          foodOption="Soda Crackers"
                          servingSize="4 pcs."
                          background="#F5F7FA"
                        ></FELTableBody>
                      </Flex>
                    </View>
                  </View>
                </Flex>
              </View>
            </View>
            <View style={styles.foodExchangeContainer}>
              <View style={{ width: "100%" }}>
                <Flex>
                  <View style={styles.foodExchangeItemContainer}>
                    <View style={{ width: "100%" }}>
                      <Flex flexDirection="column">
                        <Text style={styles.foodExchangeItemTitle}>
                          Fruit (1 Cup 60-100 Calories)
                        </Text>
                        <Image src={Fruit} style={styles.foodItemIcon} />
                        <FELTableHeader />
                        <FELTableBody
                          foodOption="Fruit (40 Calories)"
                          servingSize="1 Slice"
                          background="#FFFFFF"
                        ></FELTableBody>
                        <FELTableBody
                          foodOption="Apple, Pear, Banana, Orange"
                          servingSize="1 pc. Medium fruit"
                          background="#F5F7FA"
                        ></FELTableBody>
                        <FELTableBody
                          foodOption="Strawberry"
                          servingSize="1 1/4 Cup"
                          background="#FFFFFF"
                        ></FELTableBody>
                        <FELTableBody
                          foodOption="Grapes"
                          servingSize="4 pcs."
                          background="#F5F7FA"
                        ></FELTableBody>
                        <FELTableBody
                          foodOption="Raisins"
                          servingSize="2 tbs."
                          background="#FFFFFF"
                        ></FELTableBody>
                        <FELTableBody
                          foodOption="Fruit cocktail"
                          servingSize="3 tbs."
                          background="#F5F7FA"
                        ></FELTableBody>
                        <FELTableBody
                          foodOption="Prunes"
                          servingSize="3 pcs."
                          background="#FFFFFF"
                        ></FELTableBody>
                        <FELTableBody
                          foodOption="Fruit juice sweetened"
                          servingSize="1/4 Cup"
                          background="#F5F7FA"
                        ></FELTableBody>
                        <FELTableBody
                          foodOption="Fruit juice unsweetened"
                          servingSize="1/3 Cup"
                          background="#FFFFFF"
                        ></FELTableBody>
                      </Flex>
                    </View>
                  </View>
                </Flex>
              </View>
            </View>
          </Flex>
        </View>
        <View style={[styles.mainContainer, { marginTop: 53 }]}>
          <Flex>
            <View style={styles.foodExchangeContainer}>
              <View style={{ width: "100%" }}>
                <Flex>
                  <View style={styles.foodExchangeItemContainer}>
                    <View style={{ width: "100%" }}>
                      <Flex flexDirection="column">
                        <Text style={styles.foodExchangeItemTitle}>
                          Sugar (10-15 Calories)
                        </Text>
                        <Image src={Sugar} style={styles.foodItemIcon} />
                        <FELTableHeader />
                        <FELTableBody
                          foodOption="Condensed Milk"
                          servingSize="2 tsp."
                          background="#FFFFFF"
                        ></FELTableBody>
                        <FELTableBody
                          foodOption="Gum/Candy"
                          servingSize="1 pc. "
                          background="#F5F7FA"
                        ></FELTableBody>
                        <FELTableBody
                          foodOption="Honey"
                          servingSize="1 tbs."
                          background="#FFFFFF"
                        ></FELTableBody>
                        <FELTableBody
                          foodOption="Taho with sago"
                          servingSize="1/4 cup "
                          background="#F5F7FA"
                        ></FELTableBody>
                        <FELTableBody
                          foodOption="Sugar"
                          servingSize="1 tsp."
                          background="#FFFFFF"
                        ></FELTableBody>
                        <FELTableBody
                          foodOption="Iced Tea"
                          servingSize="3 servings"
                          background="#F5F7FA"
                        ></FELTableBody>
                        <FELTableBody
                          foodOption="Halo-halo"
                          servingSize="4 svg. "
                          background="#FFFFFF"
                        ></FELTableBody>
                        <FELTableBody
                          foodOption="Reg. Softdrinks"
                          servingSize="5 svg. "
                          background="#F5F7FA"
                        ></FELTableBody>
                      </Flex>
                    </View>
                  </View>
                </Flex>
              </View>
            </View>
            <View style={styles.foodExchangeContainer}>
              <View style={{ width: "100%" }}>
                <Flex>
                  <View style={styles.foodExchangeItemContainer}>
                    <View style={{ width: "100%" }}>
                      <Flex flexDirection="column">
                        <Text style={styles.foodExchangeItemTitle}>
                          Fat (45 Calories)
                        </Text>
                        <Image src={Fat} style={styles.foodItemIcon} />
                        <FELTableHeader />
                        <FELTableBody
                          foodOption="Butter"
                          servingSize="1 tsp."
                          background="#FFFFFF"
                        ></FELTableBody>
                        <FELTableBody
                          foodOption="Cream Cheese"
                          servingSize="1 tbsp."
                          background="#F5F7FA"
                        ></FELTableBody>
                        <FELTableBody
                          foodOption="Cooking Oil"
                          servingSize="1 tsp."
                          background="#FFFFFF"
                        ></FELTableBody>
                        <FELTableBody
                          foodOption="Mayo"
                          servingSize="1 tsp."
                          background="#F5F7FA"
                        ></FELTableBody>
                        <FELTableBody
                          foodOption="Whipping Cream"
                          servingSize="1 tsp."
                          background="#FFFFFF"
                        ></FELTableBody>
                        <FELTableBody
                          foodOption="Chocolate"
                          servingSize="1 bite size"
                          background="#F5F7FA"
                        ></FELTableBody>
                        <FELTableBody
                          foodOption="Avocado"
                          servingSize="1/2 slice"
                          background="#FFFFFF"
                        ></FELTableBody>
                        <FELTableBody
                          foodOption="Peanut butter"
                          servingSize="2 tsp."
                          background="#F5F7FA"
                        ></FELTableBody>
                      </Flex>
                    </View>
                  </View>
                </Flex>
              </View>
            </View>
          </Flex>
          <Flex>
            <View style={[styles.foodExchangeContainer2, { marginTop: 25 }]}>
              <View style={[styles.card, { width: "100%" }]}>
                <Flex>
                  <View style={styles.foodExchangeItemContainer2}>
                    <View style={{ width: "100%" }}>
                      <Flex flexDirection="column">
                        <Text style={styles.foodExchangeItemTitle}>
                          Meat and Fish
                        </Text>
                        <Image src={Fish} style={styles.foodItemIcon2} />
                        <Text
                          style={[
                            styles.foodExchangeSubItemItemTitle,
                            { marginBottom: "5px", color: "#BEDD47" },
                          ]}
                        >
                          Low Fat (60-86 Calories)
                        </Text>
                        <FELTableHeader />
                        <FELTableBody2
                          foodOption="Lean Pork"
                          servingSize="1 Matchbox size"
                          background="#FFFFFF"
                        ></FELTableBody2>
                        <FELTableBody2
                          foodOption="Tenderloin"
                          servingSize="Fat should be trimmed"
                          background="#F5F7FA"
                        ></FELTableBody2>
                        <FELTableBody2
                          foodOption="Porterhouse"
                          servingSize=""
                          background="#FFFFFF"
                        ></FELTableBody2>
                        <FELTableBody2
                          foodOption="Sirloin"
                          servingSize=""
                          background="#F5F7FA"
                        ></FELTableBody2>
                        <FELTableBody2
                          foodOption="Chicken"
                          servingSize="1 Palm Size"
                          background="#FFFFFF"
                        ></FELTableBody2>
                        <FELTableBody2
                          foodOption="Breast meat"
                          servingSize="Fat should be trimmed"
                          background="#F5F7FA"
                        ></FELTableBody2>
                        <FELTableBody2
                          foodOption="Fish"
                          servingSize="1 pc. medium size "
                          background="#FFFFFF"
                        ></FELTableBody2>
                        <FELTableBody2
                          foodOption="Flaked Tuna"
                          servingSize="1/3 Cup "
                          background="#F5F7FA"
                        ></FELTableBody2>
                        <FELTableBody2
                          foodOption="Pusit"
                          servingSize="3 pcs. "
                          background="#FFFFFF"
                        ></FELTableBody2>
                        <FELTableBody2
                          foodOption="Large Shrimps"
                          servingSize="2 pcs. "
                          background="#F5F7FA"
                        ></FELTableBody2>
                        <FELTableBody2
                          foodOption="Small Shrimps"
                          servingSize="5 pcs."
                          background="#FFFFFF"
                        ></FELTableBody2>
                        <FELTableBody2
                          foodOption="Cottage Cheese"
                          servingSize="1/3 Cup  "
                          background="#F5F7FA"
                        ></FELTableBody2>
                        <FELTableBody2
                          foodOption="Shelled Fish"
                          servingSize="1/2 Cup "
                          background="#FFFFFF"
                        ></FELTableBody2>
                        <FELTableBody2
                          foodOption="Dried Beans"
                          servingSize="1/3 Cup "
                          background="#F5F7FA"
                        ></FELTableBody2>
                        <FELTableBody2
                          foodOption="Mongo"
                          servingSize="1 Cup "
                          background="#FFFFFF"
                        ></FELTableBody2>
                      </Flex>
                    </View>
                  </View>
                  <View style={styles.foodExchangeItemContainer2}>
                    <View style={{ width: "100%" }}>
                      <Flex flexDirection="column">
                        <Image
                          src={Egg}
                          style={[styles.foodItemIcon2, { marginTop: "22px" }]}
                        />
                        <Text
                          style={[
                            styles.foodExchangeSubItemItemTitle,
                            { marginBottom: "5px", color: "#FFB41E" },
                          ]}
                        >
                          Medium Fat (100-115 Calories)
                        </Text>
                        <FELTableHeader />
                        <FELTableBody2
                          foodOption="Chicken egg"
                          servingSize="1 pc. "
                          background="#FFFFFF"
                        ></FELTableBody2>
                        <FELTableBody2
                          foodOption="Quail egg "
                          servingSize="9 pcs."
                          background="#F5F7FA"
                        ></FELTableBody2>
                        <FELTableBody2
                          foodOption="Chicken wings"
                          servingSize="1 pc."
                          background="#FFFFFF"
                        ></FELTableBody2>
                        <FELTableBody2
                          foodOption="Corned beef"
                          servingSize="3 tbs."
                          background="#F5F7FA"
                        ></FELTableBody2>
                        <FELTableBody2
                          foodOption="Pork leg (Pata)"
                          servingSize="1 pc.  (4cm diameter x 2cm thick)"
                          background="#FFFFFF"
                        ></FELTableBody2>
                        <FELTableBody2
                          foodOption="Soybean Cheese (TOFU)"
                          servingSize="1/2 Cup"
                          background="#F5F7FA"
                        ></FELTableBody2>
                        <FELTableBody2
                          foodOption="Sardines"
                          servingSize="1 pc. (10 x 4.5cm)"
                          background="#FFFFFF"
                        ></FELTableBody2>
                        <FELTableBody2
                          foodOption="Cheddar Cheese"
                          servingSize="1 slice  "
                          background="#F5F7FA"
                        ></FELTableBody2>
                        <FELTableBody2
                          foodOption="Meat loaf"
                          servingSize="2 slices "
                          background="#FFFFFF"
                        ></FELTableBody2>
                        <FELTableBody2
                          foodOption="Luncheon Meat"
                          servingSize="2 slices "
                          background="#F5F7FA"
                        ></FELTableBody2>
                        <FELTableBody2
                          foodOption="Roasted peanut"
                          servingSize="1/3 Cup "
                          background="#FFFFFF"
                        ></FELTableBody2>
                      </Flex>
                    </View>
                  </View>
                  <View style={styles.foodExchangeItemContainer2}>
                    <View style={{ width: "100%" }}>
                      <Flex flexDirection="column">
                        <Text style={styles.foodExchangeItemTitle}></Text>
                        <Image
                          src={Meat}
                          style={[styles.foodItemIcon2, { marginTop: "22px" }]}
                        />
                        <Text
                          style={[
                            styles.foodExchangeSubItemItemTitle,
                            { marginBottom: "5px", color: "#FF6262" },
                          ]}
                        >
                          High Fat (145-220 Calories)
                        </Text>
                        <FELTableHeader />
                        <FELTableBody2
                          foodOption="Ham "
                          servingSize="1 slice (3cm cube) "
                          background="#FFFFFF"
                        ></FELTableBody2>
                        <FELTableBody2
                          foodOption="Deep Fried Meat "
                          servingSize=" "
                          background="#F5F7FA"
                        ></FELTableBody2>
                        <FELTableBody2
                          foodOption="FrankFurters"
                          servingSize="1 1/2 of 12 x 1 1/3cm "
                          background="#FFFFFF"
                        ></FELTableBody2>
                        <FELTableBody2
                          foodOption="Salami"
                          servingSize="3 slices "
                          background="#F5F7FA"
                        ></FELTableBody2>
                        <FELTableBody2
                          foodOption="Vienna Sausage"
                          servingSize="4 pcs."
                          background="#FFFFFF"
                        ></FELTableBody2>
                        <FELTableBody2
                          foodOption="Hotdog"
                          servingSize="2 pcs."
                          background="#F5F7FA"
                        ></FELTableBody2>
                      </Flex>
                    </View>
                  </View>
                </Flex>
              </View>
            </View>
          </Flex>
        </View>
        <Footer />
      </View>
    </Page>
  );
};

export default PDFFelTemplate;
